import Component from "../Component";

export default class CartDrawer extends Component {
  FADE_OUT_ANIMATION_DURATION = 800; // ms

  constructor(theme, element) {
    super(theme, element);

    this.statusString = "";
    this.cartError = /** @type {HTMLDivElement} */ (document.querySelector('.cart-error-box'));

    this.cartCheckoutBtn = /** @type {HTMLButtonElement} */ (this.element.querySelector('.cart-button-checkout'));
    this.headerQuantity = /** @type {NodeListOf<Element>} */ (document.querySelectorAll('.cart-item-count-header--quantity'));

    this.cartDrawerStatus = this.element.querySelector('.js-cart-drawer-status');
    this.cartTitle = /** @type {HTMLSpanElement} */ (this.element.querySelector('.cart-drawer--title'));
    this.cartTitleText = this.cartTitle.innerText;
    this.cartDrawerTop = this.element.querySelector('.cart-drawer__top');

    const initial = document.querySelector('#initial-cart');
    if (!initial) {
      return;
    }
    const data = JSON.parse(initial.textContent);
    this.updateCartDrawer(data);

    this.cartCheckoutBtn.addEventListener('click', (event) => {
      this.cartCheckoutBtn.querySelector('.cart-button-checkout-text').classList.add('hide');
      this.cartCheckoutBtn.querySelector('.cart-button-checkout-spinner').classList.remove('hide');
    });
  }

  hideElements = (elementsList) => {
    for (const el of elementsList) {
      if (el.classList.contains('hide')) continue;
      el.classList.add('hide');
    }
  }

  showElements = (elementsList) => {
    for (const el of elementsList) {
      el.classList.remove('hide');
    }
  }

  updateStatus = (total_price) => {
    var updatedStatus = `<span>${this.theme.translations.cart_item} ${this.statusString} ${this.cartTitleText}, ${this.theme.formatMoney(total_price)}</span>`;
    this.cartDrawerStatus.innerHTML = updatedStatus;
  }

  stringToHTML = (str) => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    return doc.body.querySelector('li');
  }

  /** @param {Cart} cart */
  updateCartDrawer = async (cart) => {
    if (!cart) return;

    this.updateErrorMessage('');
    const elementsToUpdate = this.element.querySelectorAll(
      '.ajax-cart--total-price, .cart-button-checkout, .additional-checkout-buttons, .taxes-and-shipping-message, .ajax-cart--checkout-add-note, .cart-price-text'
    );
    const cartEmptyNotice = this.element.querySelectorAll('.cart-empty-box');

    if (cart.items.length === 0) {
      this.showElements(cartEmptyNotice);
      this.hideElements(elementsToUpdate);
    } else {
      this.hideElements(cartEmptyNotice);
      this.showElements(elementsToUpdate);
    }

    var cartItems = /** @type {HTMLUListElement} */ (this.element.querySelector('.cart-items'));
    cartItems.innerHTML = '';

    var self = this;

    let cartData;
    try {
      const response = await fetch('/cart?view=compare');
      cartData = await response.json();
    }
    catch (e) {
      console.error('Cart fetch failed', e);
    }

    cart.items.forEach((item, index) => {
      var templateString = document.getElementById('cart-item-template').innerHTML;
      var template = this.stringToHTML(templateString);
      var cartItem = template;
      var sellingPlanName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null;

      const templateEls = {
        image: cartItem.querySelector('.cart-item-image'),
        title: /** @type {HTMLSpanElement} */ (cartItem.querySelector('.cart-item-product-title')),
        links: /** @type {NodeListOf<Element>} */ (cartItem.querySelectorAll('.cart-item-link')),
        variant_title: /** @type {HTMLSpanElement} */ (cartItem.querySelector('.cart-item-variant-title')),
        price_per_unit: cartItem.querySelector('.cart-item-price-per-unit'),
        price: cartItem.querySelector('.cart-item-price'),
        selling_plan: cartItem.querySelector('.cart-item-selling-plan'),
        quantity: /** @type {HTMLInputElement} */ (cartItem.querySelector('.cart-item-quantity')),
        quantity_wrapper: cartItem.querySelector('.cart-item-quantity').closest('.cart-item--quantity-wrapper'),
        discounts: cartItem.querySelector('.order-discount--cart-list'),
        original_price: cartItem.querySelector('.cart-item-price-original'),
        error_message: cartItem.querySelector('.errors'),
      }

      var stockCount = parseInt(cartData.items[index].stock_count);
      var stockPolicy = cartData.items[index].stock_policy;
      var stockManagement = cartData.items[index].inventory_management;

      templateEls.quantity_wrapper.setAttribute('data-stock-count', stockCount.toString());
      templateEls.quantity_wrapper.setAttribute('data-inventory-policy', stockPolicy);
      templateEls.quantity_wrapper.setAttribute('data-inventory-management', stockManagement);

      var updateQuantity = (quantity) => {
        this.cartSetQuantity(quantity, cartItem, templateEls.quantity_wrapper);
      };

      templateEls.title.title = item.product_title;
      templateEls.title.innerText = item.product_title;
      templateEls.links.forEach(element => element.setAttribute('href', item.url));
      templateEls.price.innerHTML = this.theme.formatMoney(item.final_line_price);
      templateEls.quantity.value = item.quantity.toString();
      templateEls.quantity.setAttribute('name', 'updates[]');
      templateEls.error_message.textContent = 'You can\'t add more of this item to the cart';

      templateEls.quantity.addEventListener('change', function () {
        let new_q = parseInt(this.value.toString(), 10);
        let getQuantity = parseInt(this.parentElement.dataset.stockCount, 10);
        let inventoryPolicy = this.parentElement.dataset.inventoryPolicy;
        let inventoryManagement = this.parentElement.dataset.inventoryManagement;

        if (new_q <= getQuantity || inventoryPolicy == "continue" || inventoryManagement != "shopify") {
          templateEls.quantity.value = new_q.toString();

          setTimeout(() => {
            updateQuantity(new_q.toString());
          }, 800);

        } else {
          templateEls.quantity.value = getQuantity.toString();
          templateEls.error_message.classList.remove('hide');

          setTimeout(() => {
            updateQuantity(getQuantity.toString());
          }, 800);

        }

      });

      if (item.image) {
        templateEls.image.setAttribute('src', item.image);
        templateEls.image.setAttribute('alt', item.featured_image.alt);
      } else {
        templateEls.image.classList.add('d-none');
      }

      if (item.variant_title) {
        templateEls.variant_title.classList.remove('hide');
        templateEls.variant_title.innerText = item.variant_title;
      }

      if (item.unit_price_measurement) {
        var priceString = '<span class="price">(' + this.theme.formatMoney(item.unit_price) + ' / ' + (item.unit_price_measurement.reference_value != 1 ? item.unit_price_measurement.reference_value : '') + ' ' + item.unit_price_measurement.reference_unit + ')';
        templateEls.price_per_unit.innerHTML = priceString;
      }

      if (sellingPlanName) {
        templateEls.selling_plan.classList.remove('hide');
        templateEls.selling_plan.innerHTML = sellingPlanName;
      }

      if (item.original_line_price > item.final_line_price) {
        templateEls.original_price.innerHTML = this.theme.formatMoney(item.original_line_price);
        templateEls.original_price.classList.add('d-block');
      } else {
        templateEls.original_price.classList.add('d-none');
      }

      cartItem.querySelectorAll('.cart-item-quantity-button').forEach(item => {
        item.addEventListener('click', function () {
          let current = parseInt(templateEls.quantity.value.toString(), 10);
          let change = parseInt(this.dataset.amount, 10);
          let new_q = current + change;
          self.statusString = change > 0 ? self.theme.translations.added_to_cart : self.theme.translations.removed_from_cart;
          let getQuantity = parseInt(this.parentElement.dataset.stockCount, 10);
          let inventoryPolicy = this.parentElement.dataset.inventoryPolicy;
          let inventoryManagement = this.parentElement.dataset.inventoryManagement;

          if (new_q <= getQuantity || inventoryPolicy == "continue" || inventoryManagement != "shopify") {
            templateEls.quantity.value = new_q.toString();

            setTimeout(() => {
              updateQuantity(new_q);
            }, 800);

          } else {
            templateEls.quantity.value = getQuantity.toString();
            templateEls.error_message.classList.remove('hide');

            setTimeout(() => {
              updateQuantity(getQuantity);
            }, 800);

          }
        });
      })

      cartItem.querySelector('#cart-item-remove-button').addEventListener('click', function () {
        self.statusString = self.theme.translations.removed_from_cart;
        var new_q = 0;
        templateEls.quantity.value = new_q.toString();
        updateQuantity(new_q);
      });

      templateEls.discounts.innerHTML = '';

      item.line_level_discount_allocations.forEach(function (discount_allocation) {
        const item = document.createElement("li");
        const discountItem = document.createElement("span");

        item.classList.add('order-discount--item');
        discountItem.classList.add('order-discount--item-title');
        discountItem.innerText = discount_allocation.discount_application.title;

        item.append(discountItem);

        const discountAmount = `<span class="sr-only">${self.theme.translations.saving}</span> (- ${self.theme.formatMoney(discount_allocation.amount)})`;
        const discountEl = document.createElement("span");
        discountEl.classList.add('order-discount--cart-amount');
        discountEl.innerHTML = discountAmount;
        item.append(discountEl);

        templateEls.discounts.append(item);
      });

      cartItems.append(cartItem);
    });

    if (self.statusString) this.updateStatus(cart.total_price);

    if (this.headerQuantity) {
      document.querySelectorAll('.cart-item-count-header').forEach((item) => {
        item.textContent = cart.item_count.toString();
      });
    }

    document.querySelectorAll('.js-cart-total').forEach(item => {
      item.innerHTML = this.theme.formatMoney(cart.total_price);
    })

    var originalPrice = document.querySelector('.cart-item-original-total-price');

    if (cart.original_total_price > cart.total_price) {
      originalPrice.innerHTML = this.theme.formatMoney(cart.original_total_price);
      originalPrice.classList.add('d-block');
    } else {
      originalPrice.classList.remove('d-block');
      originalPrice.classList.add('d-none');
    }

    var cartDiscount = document.querySelector('.ajax-cart-discount-wrapper');
    cartDiscount.innerHTML = '';

    cart.cart_level_discount_applications.forEach(function (discount_application) {
      const item = document.createElement("div");
      const orderDiscount = document.createElement("span");
      const totalDiscounted = self.theme.formatMoney(discount_application.total_allocated_amount);
      const orderDiscountTitle = document.createElement("span");
      const minusSymbol = document.createElement("span");

      orderDiscount.classList.add('order-discount');
      orderDiscount.innerHTML = totalDiscounted;
      minusSymbol.innerText = '-';
      orderDiscount.querySelector('.money').prepend(minusSymbol);
      orderDiscountTitle.classList.add('order-discount--cart-title');
      orderDiscountTitle.innerText = discount_application.title;

      item.append(orderDiscount);
      item.append(orderDiscountTitle);
      item.classList.add('cart--order-discount-wrapper--indiv');

      cartDiscount.append(item);
    });

    // Free shipping msg update
    const freeShippingContainer = document.querySelector("[data-free-shipping-msg]");
    if (freeShippingContainer) {
      this.theme.fetchSection('/', 'free-shipping-msg', freeShippingContainer);
    }
  }

  updateErrorMessage = (message_string) => {
    this.cartError.innerText = message_string;
  }

  cartSetQuantity = async (quantity, cart_item, quantity_wrapper) => {
    const self = this;
    const removeItem = quantity <= 0;
    let delay = removeItem ? this.FADE_OUT_ANIMATION_DURATION : 0;
    const formData = new FormData(document.querySelector('.cart-drawer-form'));

    this.updateErrorMessage('');

    try {
      const response = await (await fetch('/cart/update.js', {
        method: "POST",
        body: formData
      })).json()

      if (response) {
        setTimeout(() => {
          self.updateCartDrawer(response);
        }, delay);
      }
    } catch (error) {
      console.error(error.message);
      self.updateErrorMessage('Unable to update item quantity');
    } finally {
      /**
      * @todo Review business logic here - removing item even if request has failed
      */

      quantity_wrapper.classList.remove('cart-item-quantity-active');
      quantity_wrapper.classList.add('cart-item-quantity-active');

      if (removeItem) {
        cart_item.classList.add('fadeOut', 'animated', 'fast');

        setTimeout(function () {
          cart_item.remove();
        }, delay);
      }
    }
  }
}
